import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { UserService } from "../../../shared/services/user.service";
import { OrderService } from "../../../shared/services/order.service";
import {
  Router,
  NavigationEnd,
  Event,
  NavigationStart,
  NavigationError,
  RoutesRecognized,
} from "@angular/router";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { CommonService } from "../../../shared/services/common.service";
@Component({
  selector: "notification",
  templateUrl: "./notification.component.html",
  styleUrls: ["./notification.component.scss"],
})
export class NotificationComponent implements OnInit {
  userLogedIn: boolean = false;
  currentUser: any;

  notificationDetails: any;

  user_img = "";
  existImg: boolean = false;
  datadone: boolean = false;
  user_full_name = "";
  usre_id: any;
  public openDashboard: boolean = false;
  page_name =
    localStorage.getItem("front-lang") == "ar"
      ? "تفاصيل الإشعار"
      : "Notification Details";
  constructor(
    private route: ActivatedRoute,
    private Commen: CommonService,
    public user: UserService,
    public order: OrderService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.checkOuth();

    this.route.params.subscribe((params: ParamMap) => {
      const notification_id = params["id"];

      if (notification_id > 0) {
        this.Commen.getNotificationDetails(notification_id).subscribe(
          (data) => {
            if (data.data) {
              this.notificationDetails = data.data;

              this.datadone = true;
            }
          }
        );

        let body = {
          notification_id: notification_id,
        };

        this.Commen.readNotification(body).subscribe((data) => {
          if (data.success) {
          } else {
            return;
          }
        });
      }
    });
  }

  checkOuth() {
    if (this.user.getToken() !== null) {
      this.userLogedIn = true;
      this.currentUser = JSON.parse(this.user.getCurrentUser());
      this.usre_id = this.currentUser.id;
      this.user_img = this.currentUser.img;
      this.existImg =
        this.user_img != "" && this.user_img != null ? true : false;
      this.user_full_name = this.currentUser.user_name;
    } else {
      this.userLogedIn = false;
      this.currentUser = null;
      this.usre_id = "";
      this.existImg = false;
      this.user_img = "";
      // this.router.navigate(["/pages/login"]);
      this.goToLogin();
    }
  }

  ToggleDashboard() {
    this.openDashboard = !this.openDashboard;
  }

  userLogOut() {
    localStorage.removeItem("currentUserFront");
    localStorage.removeItem("clientToken");
    this.userLogedIn = false;
    this.currentUser = null;
    this.usre_id = "";
    this.user_img = "";
    this.user.logout();
    // this.router.navigate(["/pages/login"]);
    this.Commen.UpdatedSetting.next("logout");
    this.router.navigate(["/"]).then(() => {
      window.location.reload();
    });
    // this.goToLogin();
  }
  loginclicked: boolean = false;

  // goToLogin() {
  //   this.loginclicked = true;
  // }
  // close() {
  //   this.loginclicked = false;
  // }

  step5Reached: boolean = false;
  stepSuccessReached: boolean = false;
  timeoutId: any;

  @ViewChild("login") loginSection;
  @ViewChild("loginFast") loginFast;

  goToLogin() {
    this.loginclicked = true;
  }

  close() {
    this.loginclicked = false;
    this.step5Reached = false;
    this.clearTimeout();
    if (this.stepSuccessReached) {
      window.location.reload();
    }
  }

  onStep5Reached() {
    this.step5Reached = true;
    this.startTimeout();
  }
  onstepSuccessReached() {
    this.stepSuccessReached = true;
  }

  startTimeout() {
    this.timeoutId = setTimeout(() => {
      this.close();
    }, 2000);
  }

  clearTimeout() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    if (!this.loginFast || !this.loginSection) {
      return;
    }
    const clickedInside = this.loginFast.nativeElement.contains(event.target);
    const clickedButton = this.loginSection.nativeElement.contains(
      event.target
    );

    if (clickedInside && this.loginclicked) {
      if (this.step5Reached) {
        this.close();
      }
    } else if (!clickedInside && clickedButton && this.loginclicked) {
      this.close();
    }
  }
}
